export const styles = {
  headerMsgConent: {
    padding: '1rem',
  },
  firstMessage: {
    color: '#e04242',
  },
};
